import { Action, createReducer, on } from '@ngrx/store';
import * as IntegrationsActions from '../actions/integrations.actions';
import { IntegrationsState } from '../models/integrations-state.model';
import { ServicesIntegration } from 'src/app/integrations/models/services-integration.enum';

export interface State {
  integrations: IntegrationsState;
  loading: boolean;
}

export const initialState: IntegrationsState = {
  currentProcess: null,
  loading: false
};

const integrationsReducer = createReducer(
  initialState,
  on(IntegrationsActions.SetIntegrationsVoluntaryChange, (state) => ({
    ...state,
    currentProcess: ServicesIntegration.voluntaryChange,
    loading: false
  })),
  on(IntegrationsActions.SetIntegrationsInvoluntaryChange, (state) => ({
    ...state,
    currentProcess: ServicesIntegration.involuntaryChange,
    loading: false
  }))
);

export function reducer(state: IntegrationsState | undefined, action: Action): IntegrationsState {
  return integrationsReducer(state, action);
}
